
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card\">\n  <header>\n    <h1 id=\"fxa-cookies-disabled-header\">{{#t}}Cookies and local storage are required{{/t}}</h1>\n  </header>\n\n  <section>\n    <div class=\"error\"></div>\n\n    <p>\n      {{#t}}Please enable cookies and local storage in your browser to access Firefox Accounts. Doing so will enable functionality such as remembering you between sessions.{{/t}}\n    </p>\n\n    <p class=\"links centered\">\n      <a href=\"https://support.mozilla.org/kb/cookies-information-websites-store-on-your-computer\" target=\"_blank\">{{#t}}Learn more{{/t}}</a>\n    </p>\n\n\n    <div class=\"button-row\">\n      <button id=\"submit-btn\" type=\"submit\">{{#t}}Try again{{/t}}</button>\n    </div>\n\n  </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/cookies_disabled.mustache
// module id = 248
// module chunks = app